import React, { Component } from 'react'
import FileSaver from 'file-saver'
import ZahtjevInputForm from '../../components/ZahtjevInputForm/ZahtjevInputForm'
import ZahtjevOutput from '../../components/ZahtjevOutput/ZahtjevOutput'
import axiosInstance from "../../api/utils/axiosInstance"
import { Modal, Button, Container } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import './ZahtjevInput.css'
import PristupnicaModal from '../../components/PDF/PristupnicaModal'
import {getFileLimits} from "../../components/Utils/UslugaVelicinaBroj";

export default class ZahtjevInput extends Component {

    state = {
        uslugaGrupaList: [],
        selectedFiles: [],
        usluga: null,
        dodatniUnos: null,
        dodatniUnosLabela: null,
        imePrezime: null,
        email: null,
        tel: null,
        podruznica: null,
        kod: null,
        suglasan: null,
        idZahtjeva: null,
        tstampZaprimanja: null,
        validated: false,
        isLoading: false,
        showAlert: false,
        alertMsg: "",
        downloading: false,
        brojDatoteka: 0,
        velicinaDatoteka: 0,
        rgfiVelicinaDatoteka: 0,
        rgfiBrojDatoteka: 0,
        epassVelicinaDatoteka: 0,
        ppBrojDatoteka: 0,
        neprofitniVelicinaDatoteka: 0,
        neprofitniBrojDatoteka: 0,
        proracuniVelicinaDatoteka: 0,
        proracuniBrojDatoteka: 0,
        ponipVelicinaDatoteka: 0,
        steVelicinaDatoteka: 0,
        steBrojDatoteka: 0,
        certVelicinaDatoteka: 0,
        certBrojDatoteka: 0,
        ponip4BrojDatoteka: 0,
        showCaptcha: 0,
        showModal: false,
        errorMsg: "",
        appVersion: "",
        podruznicaList: [],
        listToShow: 0,
        uslugePicked: false,
        didClick: false,
        showAdditionalField: null,
        requiredField: true,
        verificationSts: false,
        verifiedSuccess: false,
        mail: 0,
        showPristupnicaModal: false,
    }

    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();

    }

    checkHash() {
        try {
            if (!this.state.didClick) {
                var hash = window.location.hash.substring(1);
                if (hash !== null && hash !== "") {
                    if (hash.includes("grupa-")) {
                        var element = document.getElementById(hash)
                        if (element !== null) {
                            element.click();
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                            this.setState({ didClick: true });
                        }
                    } else if (Number.isInteger(parseInt(hash))) {
                        var breakFlag = false;                        
                        for (var grupa in this.state.uslugaGrupaList) {
                            for (var usluga in this.state.uslugaGrupaList[grupa].uslugaList) {
                                if (hash === this.state.uslugaGrupaList[grupa].uslugaList[usluga].idUsluge.toString()) {
                                    var elementParent = document.getElementById("grupa-" + (parseInt(this.state.uslugaGrupaList[grupa].sifraGrupe)))
                                    if (elementParent != null) {
                                        elementParent.click()
                                        breakFlag = true
                                        break
                                    }
                                }
                            }
                            if (breakFlag) {
                                break
                            }
                        }

                        var elementChild = document.getElementById(hash);
                        if (elementChild !== null) {
                            elementChild.parentElement.click();
                            elementChild.parentElement.scrollIntoView();
                            this.setState({ didClick: true });
                        }
                    }

                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    verifyMail() {
        if (window.location.href.includes("verify") && !this.state.verificationSts) {
            var hash = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            axiosInstance.post("/verify/" + hash).then(res => {
                this.setState({ verifiedSuccess: true });
                this.setState({ showModal: true, errorMsg: "Vaša e-mail adresa je uspješno verificirana." });
            }).catch(error => {
                this.setState({ verifiedSuccess: false });
                this.setState({ showModal: true, errorMsg: error.response != null ? error.response.data.error.message : "Neuspješna verifikacija Vaše e-mail adrese." });
            })
            this.setState({ verificationSts: true });
            window.history.replaceState(null, null, window.location.pathname);
        }
    }

    componentDidMount() {
        this.getLists();
        this.getParamsObrade();

        // Check initial hash when component mounts
        if (window.location.hash === '#eracunplus') {
            this.setState({ showPristupnicaModal: true });
        }

        // Listen for hash changes
        window.addEventListener('hashchange', () => {
            if (window.location.hash === '#eracunplus') {
                this.setState({ showPristupnicaModal: true });
            } else {
                this.setState({ showPristupnicaModal: false });
            }
        });
    }

    componentWillUnmount() {
        // Cleanup event listener
        window.removeEventListener('hashchange', () => { });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.idZahtjeva) {
            this.setState({ idZahtjeva: null });
            this.setState({ tstampZaprimanja: null })
            this.setState({ selectedFiles: [] });
            this.setState({ validated: false });
            this.setState({ isLoading: false });
            this.setState({ showAlert: false });
            this.setState({ showAdditionalField: null });
            this.setState({ requiredField: null });
            this.setState({ dodatniUnos: null });
        }
    }

    componentDidUpdate(prevProps) {

        if (this.state.selectedFiles.length === 0 && document.getElementById('inputGroupFile04') != null) {
            document.getElementById('inputGroupFile04').value = null;
        }

        this.verifyMail();
    }

    getLists = () => {
        axiosInstance.get("/predajaZahtjeva").then(res => {
            const uslugaGrupaList = res.data.uslugaGrupaList;
            const podruznicaList = res.data.podruznicaList;
            this.setState({ uslugaGrupaList, podruznicaList });
            this.checkHash();
        }).catch(error => {
            this.setState({ showModal: true, errorMsg: "Pogreška prilikom učitavanja stranice." });
        })
    }

    getParamsObrade = () => {
        axiosInstance.get("/parametri").then(res => {
            const brojDatoteka = res.data.brojDatoteka;
            const velicinaDatoteka = res.data.velicinaDatoteka;
            const rgfiVelicinaDatoteka = res.data.rgfiVelicinaDatoteka;
            const rgfiBrojDatoteka = res.data.rgfiBrojDatoteka;
            const epassVelicinaDatoteka = res.data.epassVelicinaDatoteka;
            const ppBrojDatoteka = res.data.ppBrojDatoteka;
            const neprofitniVelicinaDatoteka = res.data.neprofitniVelicinaDatoteka;
            const neprofitniBrojDatoteka = res.data.neprofitniBrojDatoteka;
            const proracuniVelicinaDatoteka = res.data.proracuniVelicinaDatoteka;
            const proracuniBrojDatoteka = res.data.proracuniBrojDatoteka;
            const ponipVelicinaDatoteka = res.data.ponipVelicinaDatoteka;
            const ponip4BrojDatoteka = res.data.ponip4BrojDatoteka;
            const steVelicinaDatoteka = res.data.steVelicinaDatoteka;
            const steBrojDatoteka = res.data.steBrojDatoteka;
            const certVelicinaDatoteka = res.data.certVelicinaDatoteka;
            const certBrojDatoteka = res.data.certBrojDatoteka;
            const showCaptcha = res.data.showCaptcha;
            const mail = res.data.mail;
            const appVersion = res.data.verzija;
            this.setState({
                brojDatoteka, velicinaDatoteka, rgfiVelicinaDatoteka, rgfiBrojDatoteka, epassVelicinaDatoteka, ppBrojDatoteka,
                neprofitniVelicinaDatoteka, neprofitniBrojDatoteka, proracuniBrojDatoteka, proracuniVelicinaDatoteka, ponipVelicinaDatoteka, ponip4BrojDatoteka, steVelicinaDatoteka, steBrojDatoteka, certVelicinaDatoteka, certBrojDatoteka, showCaptcha, mail, appVersion
            });
        }).catch(error => {
            this.setState({ showModal: true, errorMsg: "Pogreška prilikom učitavanja stranice." });
        });
    }

    handleFile = (e) => {
        e.preventDefault();
        this.setState({ showAlert: false });
        const { velicinaDatoteka, brojDatoteka } = getFileLimits(this.state);

        var flag = true;
        for (var j = 0; j < e.target.files.length; j++) {
            if (e.target.files[j].type !== 'application/pdf') {
                flag = false;
            }
        }
        var listOfFiles = [];
        this.state.selectedFiles.map((file) =>
            listOfFiles.push(file));
        if (!flag) {
            this.setState({ showAlert: true });
            this.setState({ alertMsg: "Moguće je predati samo dokument u PDF formatu." });
        } else if ((listOfFiles.length + e.target.files.length) > brojDatoteka) {
            this.setState({ showAlert: true });
            const msg = (<span>Nije moguće odabrati više od {brojDatoteka} dokumenata za predaju.</span>)
            this.setState({ alertMsg: msg });
            e.stopPropagation();
        } else {
            var sizeOfFiles = 0;
            for (var k = 0; k < listOfFiles.length; k++) {
                sizeOfFiles = sizeOfFiles + listOfFiles[k].size;
            }
            for (var i = 0; i < e.target.files.length; i++) {
                listOfFiles.push(e.target.files[i]);
                sizeOfFiles = sizeOfFiles + e.target.files[i].size;
            }
            if (((sizeOfFiles / 1024) / 1024) > velicinaDatoteka) {
                this.setState({ showAlert: true });
                const msg2 = (<span>Nije moguće odabrati dokument jer time prelazite ograničenje od {velicinaDatoteka}MB za predaju dokumentacije.</span>)
                this.setState({ alertMsg: msg2 });
            } else {
                this.setState({ selectedFiles: listOfFiles }, () => {
                    this.checkIfGroupValid();
                });

            }

        }

    }

    handleSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (!this.checkIfFilesValid()) {
            this.setState({ validated: false });
        } else if (form.checkValidity() === false) {
            this.setState({ validated: true });
        } else {
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.execute();
            } else {
                this.filesToString(this.state.selectedFiles);
            }
            this.setState({ isLoading: true });
            //this.filesToString(this.state.selectedFiles);
        }
    }

    filesToString = (files) => {
        var dokumenti = [];

        if (files.length === 0) {
            this.submitRequest(null);
        } else {
            for (var i = 0; i < files.length; i++) {
                const fileReader = new FileReader();
                const file = files[i];
                fileReader.readAsDataURL(file);
                fileReader.onload = () => {
                    const base64 = fileReader.result;
                    const str = base64.substr(base64.indexOf(",") + 1);
                    const dokument = {
                        data: str,
                        naziv: file.name
                    }
                    dokumenti.push(dokument);
                    if (dokumenti.length === this.state.selectedFiles.length) {
                        this.submitRequest(dokumenti);
                    }
                }
            }
        }

    }

    submitRequest = (dokumenti) => {
        var bcrypt = require('bcryptjs');
        const saltRounds = 10;
        const userKod = this.state.kod;
        const idUsluge = this.state.usluga;
        const dodatniUnos = this.state.dodatniUnos;
        const imePrezime = this.state.imePrezime;
        const email = this.state.email;
        const tel = this.state.tel;
        const podruznica = this.state.podruznica;
        const suglasan = this.state.suglasan === true ? "on" : "off";
        const thisInstance = this;
        const captchaResponse = (this.state.showCaptcha === 1 ? this.recaptchaRef.current.getValue() : null);
        const instance = this;
        bcrypt.genSalt(saltRounds, function (err, salt) {
            bcrypt.hash(userKod, salt, function (err, hash) {
                const zahtjev = {
                    idUsluge: idUsluge,
                    dokumenti: dokumenti,
                    dodatniUnos: dodatniUnos,
                    imePrezime: imePrezime,
                    email: email,
                    tel: tel,
                    podruznica: podruznica,
                    kod: hash,
                    suglasan: suglasan,
                    captchaResponse: captchaResponse
                }
                axiosInstance.post("/predajaZahtjeva", zahtjev).then(res => {
                    thisInstance.setState({
                        idZahtjeva: res.data.idZahtjeva,
                        tstampZaprimanja: res.data.tstampZaprimanja
                    });
                }).catch(error => {
                    var errorMsg = null;
                    if (error.response.data.error.status !== null) {
                        errorMsg = error.response.data.error.message + " (" + error.response.data.error.status + ")";
                    } else {
                        errorMsg = error.response.data.error.message;
                    }
                    instance.setState({ showModal: true, errorMsg: errorMsg });
                });
            });
        });

    }

    handleChange = (e, tipPredajeDoc, dodatniUnosLabela) => {

        const { name, value, type, checked } = e.target;

        if (e.target.name === 'usluga') {
            this.setState({
                uslugePicked: true,
                showAdditionalField: tipPredajeDoc
            }, () => {
                if (this.state.showAdditionalField !== 1) {
                    this.setState({
                        dodatniUnos: null,
                        requiredField: true
                    })
                } else {
                    this.checkIfGroupValid();
                }
            })
            if (dodatniUnosLabela !== null) {
                this.setState({
                    dodatniUnosLabela: dodatniUnosLabela
                })
            }

        } else if (e.target.name === 'dodatniUnos') {
            this.checkIfGroupValid();
        }

        this.setState({
            [name]: value
        }, () => {
            this.checkIfFilesValid();
        });

        this.setState({ [name]: type === 'checkbox' ? checked : value }, () => {
            if (name === 'usluga') {
                this.setState({
                    uslugePicked: true,
                    dodatniUnos: null,
                    dodatniUnosLabela: dodatniUnosLabela.length > 0 ? dodatniUnosLabela[0] : null,
                    showAdditionalField: tipPredajeDoc,
                    requiredField: tipPredajeDoc === 1 ? false : true,
                    selectedFiles: []
                })
                document.getElementById('dodatniUnos') && (document.getElementById('dodatniUnos').value = '');
            }
        });

    }

    checkIfGroupValid = () => {
        if ((document.getElementById("dodatniUnos") != null && document.getElementById("dodatniUnos").value !== null && document.getElementById("dodatniUnos").value !== "") || (this.state.selectedFiles.length !== 0)) {
            this.setState({ requiredField: false })
        } else {
            this.setState({ requiredField: true })
        }
    }

    handleDelete = (e, index) => {
        e.preventDefault();
        this.setState({
            selectedFiles: this.state.selectedFiles.filter((_, i) => i !== index)
        }, () => {
            this.checkIfGroupValid();
            if (this.checkIfFilesValid())
                this.setState({ showAlert: false });
        });

    }

    handleDownloadPdf = (e, idUslugaLink) => {
        e.preventDefault();
        this.setState({ downloading: true });
        axiosInstance.get("/downloadPdf/" + idUslugaLink).then(res => {
            this.savePdfFromData(res.data);
            this.setState({ downloading: false });
        }).catch(error => {
            if (error.response.data.error.message != null) {
                this.setState({ showModal: true, errorMsg: error.response.data.error.message });
            } else {
                this.setState({ showModal: true, errorMsg: "Nije moguće izvršiti traženu akciju." });
            }
        });
    }

    handleDownloadTos = (e) => {
        e.preventDefault();
        this.setState({ downloading: true });
        axiosInstance.get("/tos/2").then(res => {
            this.savePdfFromData(res.data);
            this.setState({ downloading: false });
        }).catch(error => {
            this.setState({ showModal: true, errorMsg: "Nije moguće izvršiti traženu akciju." });
        });
    }

    savePdfFromData = (data) => {
        var binaryString = window.atob(data.pdf);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        var newBlob = new Blob([bytes], { type: "application/pdf" });

        FileSaver.saveAs(newBlob, data.fileName);
    }

    handleCloseModal = () => {
        this.setState({ showModal: false, isLoading: false });
        if (this.state.verificationSts) {
            window.location.href = '/'
        }
    }

    handleCaptchaChange = () => {
        this.filesToString(this.state.selectedFiles);
    }

    filterList = (e, index) => {
        e.preventDefault();
        if (this.state.listToShow === index) {
            this.setState({ listToShow: 0 });
        } else {
            this.setState({ listToShow: index });
        }
    }

    checkIfFilesValid = () => {
        const { velicinaDatoteka, brojDatoteka } = getFileLimits(this.state);

        var sizeOfFiles = 0;
        var listOfFiles = [];
        var flag = true;

        this.state.selectedFiles.map((file) =>
            listOfFiles.push(file));

        for (var k = 0; k < listOfFiles.length; k++) {
            sizeOfFiles = sizeOfFiles + listOfFiles[k].size;
            if (listOfFiles[k].type !== 'application/pdf')
                flag = false;
        }

        if (!flag) {
            this.setState({ showAlert: true });
            this.setState({ alertMsg: "Moguće je predati samo dokument u PDF formatu." });
        } else if (((sizeOfFiles / 1024) / 1024) > velicinaDatoteka) {
            this.setState({ showAlert: true });
            const msg = (<span>Odabrani dokumenti prelaze ograničenje od {velicinaDatoteka}MB za predaju dokumentacije.</span>)
            this.setState({ alertMsg: msg });
            return false;
        } else if (listOfFiles.length > brojDatoteka) {
            this.setState({ showAlert: true });
            const msg = (<span>Nije moguće odabrati više od {brojDatoteka} dokumenata za predaju.</span>)
            this.setState({ alertMsg: msg });
            return false;
        } else {
            this.setState({
                showAlert: false,
                alertMsg: ""
            });
            return true;
        }

    }

    handleOpenPristupnicaModal = () => {
        this.setState({ showPristupnicaModal: true });
    };


    handleClosePristupnicaModal = () => {
        window.location.hash = ''
        /* this.setState({ showPristupnicaModal: false }); */
    };


    handleSubmitPristupnicaData = (pristupnicaData) => {
        // This function is called when the form inside PristupnicaModal is "submitted" 
        // For now, it's mainly for triggering PDF generation. 
        // If you needed to send this data to your backend, you'd do it here. 
        // The PDF generation link is now within PristupnicaForm itself. 
        // You could potentially close the modal here if PDF is generated, or let user close it. 
        this.handleClosePristupnicaModal();
    };

    render() {

        return (
            <>
                <Container>

                    <PristupnicaModal show={this.state.showPristupnicaModal} onHide={this.handleClosePristupnicaModal} handleSubmitPristupnica={this.handleSubmitPristupnicaData} />

                    {this.state.idZahtjeva ?
                        (<section aria-label="Informacije o predanom zahtjevu"><ZahtjevOutput idZahtjeva={this.state.idZahtjeva} tstampZaprimanja={this.state.tstampZaprimanja} /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> </section>) :
                        (<section aria-label="Forma za unos zahtjeva" className='unos-zahtjeva'><ZahtjevInputForm handleChange={this.handleChange} handleSubmit={this.handleSubmit} handleFile={this.handleFile} handleDelete={this.handleDelete} handleDownloadTos={this.handleDownloadTos} handleDownloadPdf={this.handleDownloadPdf}
                            selectedFiles={this.state.selectedFiles} uslugaGrupaList={this.state.uslugaGrupaList} podruznicaList={this.state.podruznicaList} validated={this.state.validated} isLoading={this.state.isLoading} showAlert={this.state.showAlert}
                            alertMsg={this.state.alertMsg} recaptchaRef={this.recaptchaRef} filterList={this.filterList} listToShow={this.state.listToShow}
                            uslugePicked={this.state.uslugePicked} pickedUslugaId={this.state.usluga} showAdditionalField={this.state.showAdditionalField}
                            dodatniUnosLabela={this.state.dodatniUnosLabela}
                            requiredField={this.state.requiredField} mail={this.state.mail}
                        />
                            {this.state.showCaptcha === 1 ?
                                <ReCAPTCHA
                                    aria-hidden="true"
                                    ref={this.recaptchaRef}
                                    sitekey="6LeW6OMUAAAAAH7Ck0ZLGjaA7Gh6obSk7c4CSDkn"
                                    size="invisible"
                                    onChange={this.handleCaptchaChange}
                                /> : null
                            }
                        </section>)
                    }

                    <Modal show={this.state.showModal} onHide={this.handleCloseModal} centered role="alertdialog">
                        <Modal.Header closeButton>
                            {this.state.verifiedSuccess ?
                                <Modal.Title role="alert">Uspješna verifikacija</Modal.Title>
                                :
                                <Modal.Title role="alert">Došlo je do pogreške</Modal.Title>
                            }
                        </Modal.Header>
                        <Modal.Body role="alert">{this.state.errorMsg !== "" ? this.state.errorMsg : "Pogreška u radu aplikacije. Pokušajte ponovno."}</Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.handleCloseModal} >
                                Zatvori
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
                <footer className="footer" aria-label="Podnožje">
                    <span className="version">{this.state.appVersion}</span>
                </footer>


            </>
        )
    }
}
